import {
  defer,
  distinctUntilChanged,
  finalize,
  map,
  type Observable,
} from 'rxjs';
import {
  dispatchAction,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';
import { setIsViewExporting } from '@ardoq/export/state';
import { fileExportChanged } from './actions';

const countExport = (
  count: number,
  { isExporting }: { isExporting: boolean }
): number => Math.max(0, count + (isExporting ? 1 : -1));

const exportsInProgress$ = persistentReducedStream('exportsInProgress$', 0, [
  reducer(setIsViewExporting, countExport),
  reducer(fileExportChanged, countExport),
]);

export const isFileExporting$: Observable<boolean> = exportsInProgress$.pipe(
  map(count => count > 0),
  distinctUntilChanged()
);

export const trackFileExport = <T>(source$: Observable<T>): Observable<T> =>
  defer(() => {
    dispatchAction(fileExportChanged({ isExporting: true }));
    return source$.pipe(
      finalize(() => dispatchAction(fileExportChanged({ isExporting: false })))
    );
  });
